/**
 * Bullet
 *
 * Reusable bullet-list row: renders a `•` glyph followed by inline content,
 * aligned to the top so multi-line text wraps cleanly.
 */

import React from 'react';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';

interface BulletProps {
  children: React.ReactNode;
  color: string;
  fontSize: string;
}

export const Bullet: React.FC<BulletProps> = ({ children, color, fontSize }) => {
  const responsive = useResponsiveDesign();
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <span style={{ color, fontSize, marginRight: responsive.spacing.xs }}>{'\u2022'}</span>
      <div style={{ flex: 1, color, fontSize }}>{children}</div>
    </div>
  );
};
